'use es6';

import { Redirect, useLocation, useParams } from 'react-router-dom';
import { useQueryParamString } from '../../hooks/useQueryParams';
import { useDefaultViewId } from '../../hooks/viewTabs';
import { viewLink } from '../../utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Redirector() {
  const {
    pathname
  } = useLocation();
  const {
    taskId
  } = useParams();
  const queryParamsString = useQueryParamString();
  const {
    isLoading,
    defaultViewId
  } = useDefaultViewId();
  if (isLoading) {
    return null;
  }
  const url = `${viewLink({
    currentPathname: pathname,
    taskId,
    viewId: defaultViewId
  })}${queryParamsString}`;
  return /*#__PURE__*/_jsx(Redirect, {
    to: url
  });
}